import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { fontFamilyAlt, mediaQueriesBP } from "@waytek/Utilities/variables";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

export interface OrderDetailsShipmentWeightStyles {
    titleText?: TypographyPresentationProps;
    shipmentWeightText?: TypographyPresentationProps;
    wrapper?: InjectableCss;
}

export const paymentTermsStyles: OrderDetailsShipmentWeightStyles = {
    wrapper: {
        css: css`
            ${mediaQueriesBP.maxMD} {
                margin-bottom: 20px;
            }
        `,
    },

    titleText: {
        variant: "h6",
        css: css`
            font-family: ${fontFamilyAlt};
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.71;
            letter-spacing: normal;
            margin-bottom: 5px;
        `,
    },

    shipmentWeightText: {
        css: css`
            font-family: ${fontFamilyAlt};
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.71;
            letter-spacing: normal;
        `,
    },
};
const styles = paymentTermsStyles;

const OrderDetailsShipmentWeight = () => {
    const { value: order } = useContext(OrderStateContext);

    if (
        order == null ||
        order.properties.shipmentPackageProperties == null ||
        order.properties.shipmentPackageProperties.length === 0
    ) {
        return null;
    }

    const orderShippingInfo: any[] = JSON.parse(order.properties.shipmentPackageProperties);

    if (orderShippingInfo.length === 0) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography as="h3" {...styles.titleText}>
                {translate("Total Shipment Weight")}
            </Typography>
            <Typography {...styles.shipmentWeightText}>{`${orderShippingInfo[0].freight} lbs`}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsShipmentWeight,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
